import { CategoryTypeEnum } from 'entities/Files/types';
import custom_model from 'shared/assets/categories/custom_model.png';
import generative_model from 'shared/assets/categories/generative_model.png';

export type Category = {
	id: CategoryTypeEnum;
	label: string;
	description?: string;
	img: string;
	type: string;
	customModelId?: string;
	generativeId?: string;
};

export const CustomCategory = {
	id: CategoryTypeEnum.custom,
	label: 'sidebar.menu./files/custom',
	description: 'start_recognition.category_descriptions.custom',
	img: custom_model,
	type: 'shared_texts.doc_type_custom',
};

export const GenerativeCategory = {
	id: CategoryTypeEnum.generative_model,
	label: 'sidebar.menu./generative-model',
	description: 'start_recognition.category_descriptions.generative',
	img: generative_model,
	type: 'shared_texts.doc_type_generative',
};

export const CategoriesList: Array<Category> = [CustomCategory, GenerativeCategory];
